import React, { useState } from "react";
import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe } from "@fortawesome/pro-duotone-svg-icons";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import * as locales from "react-date-range/dist/locale";
import { Calendar } from "react-date-range";
import { addDays } from "date-fns";
import TimeField from "react-simple-timefield";
import { useTranslate } from "@tolgee/react";
import { useDispatch, useSelector } from "react-redux";
import { lomavisCreatorRootState } from "../../../../../pages/lomavisCreator";
import { updateUseSeparatePublicationDateTime } from "../../../../../redux/slices/lomavisCreator/lomavisCreator";
import PublicationDateTimeBox from "./PublicationDateTimeBox";
import { ALL, PLATFORM_LIST } from "../../../../../config/constants";
import CreatorSwitchButton from "../../commonElements/creatorSwitchButton";
import CreatorTitle from "../../commonElements/creatorTitle";

const Planning = () => {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const [currentPlatform, setCurrentPlatform] = useState("");

  const [currentInput, setCurrentInput] = useState("none");
  const [time, setTime] = useState("");

  const [toggleAllPlatform, setToggleAllPlatform] = useState("");

  const [locale, setLocale] = useState("enGB");
  const [date, setDate] = useState(null);

  const formatDate = (inputDate) => {
    if (!inputDate) {
      return null;
    }
    const year = inputDate.getFullYear();
    const month = String(inputDate.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(inputDate.getDate()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  };

  const useSparatePublicationDatetime = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.use_separate_publication_datetime
  );

  const platformEnabled = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.platformEnabled
  );

  return (
    <div className="relative">
      <div className="d-flex flex-column gap-3">
        <div className="d-flex align-items-center">
          <h3 className="m-0 p-0 me-2">
            {t(`lomavisCreator.title.publication_planning_head`)}
          </h3>
          <OverlayTrigger
            placement="right"
            overlay={
              <Tooltip>
                <span className="text-gray-400 fw-bold d-block fs-7 text-start">
                  {t(`lomavisCreator.tooltip.publication_planning_text`)}
                </span>
              </Tooltip>
            }
          >
            <i className="fa-duotone fa-circle-info  cursor-pointer "></i>
          </OverlayTrigger>
        </div>
      </div>

      <div className="d-flex flex-column gap-2">
        <div
          style={{}}
          className="d-flex justify-content-end gap-2 align-items-center"
        >
          <CreatorSwitchButton
            OnText={t("lomaviCreator.seperate_publication_datetime")}
            tooltipText={t(
              "lomavisCreator.seperate_publication_datetime_tooltip"
            )}
            isOn={useSparatePublicationDatetime}
            onClick={() =>
              dispatch(
                updateUseSeparatePublicationDateTime(
                  !useSparatePublicationDatetime
                )
              )
            }
          />
        </div>

        {!useSparatePublicationDatetime && (
          <PublicationDateTimeBox
            platform={ALL}
            currentPlatform={currentPlatform}
            setCurrentPlatform={setCurrentPlatform}
          />
        )}

        {useSparatePublicationDatetime &&
          PLATFORM_LIST.map(
            (platform) =>
              platformEnabled[platform] && (
                <PublicationDateTimeBox
                  platform={platform}
                  currentPlatform={currentPlatform}
                  setCurrentPlatform={setCurrentPlatform}
                />
              )
          )}
      </div>

      {currentPlatform && (
        <div
          style={{
            width: "100vh",
            height: "100wh",
            zIndex: 111,
            top: "0px",
            left: "0px",
          }}
          onClick={() => {
            setCurrentPlatform(null);
          }}
          className="underlay position-fixed w-100 h-100 d-flex justify-content-end overflow-hidden"
        ></div>
      )}
    </div>
  );
};

export default Planning;
